/** /my-coaching/business/nova/knows — What NOVA knows. */

import { createFileRoute } from "@tanstack/react-router";

import { WhatNovaKnowsPage } from "~/components/nova/knows/what-nova-knows-page";
import { placementVideosQueryOptions } from "~/lib/queries/learningQuery";
import {
  novaAssetsQueryOptions,
  novaKnowsQueryOptions,
} from "~/lib/queries/novaAssetsQuery";

export const Route = createFileRoute("/_user/my-coaching/business/nova/knows")({
  staticData: { title: "What NOVA knows" },
  loader: async ({ context }) => {
    const userId = context.user.clerkUserId;
    // An optimisation that hands SSR the records and videos, not the page's
    // data source: the page reads the same queries and shows its own failure
    // and retry.
    await Promise.all([
      context.queryClient
        .ensureQueryData(novaAssetsQueryOptions(userId))
        .catch(() => undefined),
      context.queryClient
        .ensureQueryData(novaKnowsQueryOptions(userId))
        .catch(() => undefined),
      context.queryClient
        .ensureQueryData(placementVideosQueryOptions())
        .catch(() => undefined),
    ]);
    return { userId };
  },
  component: WhatNovaKnowsRoute,
});

function WhatNovaKnowsRoute() {
  const { userId } = Route.useLoaderData();
  return <WhatNovaKnowsPage userId={userId} />;
}
